import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import simpleMarkdown from '@/views/simpleMarkdown'
import deletion from '@/views/deletion'
import shop from '@/views/shop/index'
import payment from '@/views/shop/recharge/payment'
import result from '@/views/shop/recharge/result'
// import paymentSuccess from '@/views/shop/recharge/success'
// import paymentFailure from '@/views/shop/recharge/failure'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: index,
      name: 'Home'
    },
    {
      path: '/privacypolicy',
      name: 'privacyPolicy',
      component: simpleMarkdown
    },
    {
      path: '/termsservice',
      name: 'termsService',
      component: simpleMarkdown
    },
    {
      path: '/accountDeletion',
      name: 'accountDeletion',
      component: deletion
    },
    {
      path: '/store',
      component: shop,
      name: 'Store'
    },
    {
      path: '/store/payment',
      component: payment,
      name: 'Payment'
    },
    // ,
    // {
    //   path: '/creditcard/payment',
    //   component: payment,
    //   name: 'creditPayment',
    //   props: { channel: 'credit' }
    // },
    {
      path: '/store/payment/result',
      component: result,
      name: 'PaymentResult'
    }
    // {
    //   path: '/payment/success',
    //   component: paymentSuccess,
    //   name: 'PaymentSuccess'
    // },
    // {
    //   path: '/payment/failure',
    //   component: paymentFailure,
    //   name: 'PaymentFailure'
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js